import './style.css';
const Intro = ()=>{
    return(
        <div className="intro">
            <div>
                <h3 style={{textAlign:'center', paddingTop: '2em'}}>협회 소개</h3>
                <div className='intro_box'>
                    <h4>한국하모니카교육협회 KHEA(Korea Harmonica Education Assciation)</h4>
                    <p>
                    한국하모니카교육협회는 하모니카 음악의 대중화를 위한 교육과 연주활동을 하고 있는, 국내최고의 위상과 실력을 지닌 단체로서 문화체육관광부에 등록된 비영리 민간단체이다.<br/>
                    현재까지 200여명의 전문 강사들을 양성하였고, 이들은 현재 안팎에서 활발하게 활동을 전개하고 있다. <br/>
                    또한 한국하모니카교육협회는 연주자들을 모아 하모니카오케스트라를 설립함으로써 하모니카 오케스트라 음악의 발전에 많은 공헌을 했다. <br/>
                    2013년부터는 서울국제하모니카페스티벌(SIHF: Seoul International Harmonica Festival)을 진행함으로써 한국의 하모니카 음악의 국제적 역량을 끌어올렸고, 축제 때 해외 유명 연주자들을 초청함으로써 하모니카를 통한 국제교류의 물꼬를 텄다.<br/>
                    한편 한국하모니카교육협회는 문화소외계층의 문화향유 기회 확대에도 노력을 기울이고 있으며 저소득, 장애인, 가정주부, 노인들을 대상으로 프로그램을 운영하고 있다.
                    </p>
                </div>
                <div className='intro_box'>
                    <h4>설립목적</h4>
                    <p>
                    - 국내 하모니카 음악의 보급과 음악을 통한 국민적 정서 함양<br/>
                    - 하모니카 교육을 통한 문화소외계층의 문화예술 향유기회 확대와 삶의 질 향상, 건전한 사회분위기 조성
                    </p>
                </div>
                <div className='intro_box'>
                    <h4>주요사업</h4>
                    <p>
                    - 서울국제하모니카페스티벌 개최<br/>
                    - 지역내 가족구성원, 이웃들을 대상으로 '이웃사랑·가족사랑 하모니카 교실' 운영 및 '사랑! 행복! 나눔! 콘서트' 개최<br/>
                    - 문화소외계층민과 청소년을 대상으로 '사랑과 행복나눔 하모니카 교실' 운영 <br/>
                    - '하모니카를 통한 소외계층 아동의 문화감수성 향상 프로젝트' 수행 <br/>
                    - 전문강사 및 연주자 양성교육 <br/>
                    - 연주단체 운영 (코리아유스오케스트라, 코리아하모니카오케스트라, 코리아시니어오케스트라, 중주팀)<br/>
                    </p>
                </div>
                <div className='intro_box'>
                    <h4>연혁</h4>
                    <p>
                    - 2001년 4월 : 하모니카교육센터 창립 <br/>
                    - 2004년 4월 : 한국하모니카교육협회로 명칭변경<br/>
                    - 2010년 1월 28일: 문화체육관광부 비영리 민간단체 등록 (등록번호: 2010- 1호)<br/>
                    - 2013년 7월 : 제1회 서울국제하모니카페스티벌 개최<br/>
                    - 2014년 7월 25일 ~27일 : 제2회 서울국제하모니카페스티벌 개최<br/>
                    - 2015년 7월 31일 ~ 8월 2일 : 제3회 서울국제하모니카페스티벌 개최<br/>
                    - 2016년 7월 29일 ~ 31일 : 제4회 서울국제하모니카페스티벌 개최<br/>
                    - 2017년 8월 3일~ 6일 : 제5회 서울국제하모니카페스티벌 개최<br/>
                    - 2018년 8월 3일~ 5일 : 제6회 서울국제하모니카페스티벌 개최<br/>
                    - 2019년 8월 2일~ 4일 : 제7회 서울국제하모니카페스티벌 개최<br/>
                    - 2020년 ~ 2021년 : 영등포구 동네방네모두를 위한 하모니카오케스트라(서울시 생활예술지원사업)<br/>
                    - 2021년 10월 8일~ 10일 : 제8회 서울국제하모니카페스티벌 개최<br/>
                    - 2023년 8월 4일~ 6일 : 제9회 서울국제하모니카페스티벌 개최<br/>
                    - 2024년 8월 2일~ 4일 : 제10회 서울국제하모니카페스티벌 개최<br/>
                    - 2025년 8월 1일~ 3일 : 제11회 서울국제하모니카페스티벌 개최<br/>
                    - 2026년 7월 31일 ~ 8월 2일 : 제12회 서울국제하모니카페스티벌 개최<br/>

                    </p>
                </div>
            </div>
        </div>
    )
}
export default Intro;
